import { createElement } from 'react';
import { Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';

let instrumentedRoutes: typeof Routes | undefined;

/**
 * `<Routes>` instrumented for Sentry: each navigation's transaction is named
 * after the matched route pattern (`/organizations/:id/edit`), not the URL.
 * Without this wrapper the tracing integration has no route tree to match
 * against and falls back to the raw pathname, giving one transaction name per
 * id.
 *
 * The wrap happens at first render, not at import. On @sentry/react 10.x,
 * `wrapReactRouterRouting` returns the plain `Routes` — silently — when it
 * runs before `Sentry.init` has handed the integration its router hooks, so
 * wrapping at module scope would make route naming depend on import order.
 * 11.x looks the hooks up per render and no longer has that trap; wrapping
 * late is harmless there.
 */
export const SentryRoutes: typeof Routes = (props) => {
  instrumentedRoutes ??= Sentry.wrapReactRouterRouting(Routes);
  return createElement(instrumentedRoutes, props);
};
